export const NotificationChannel = Object.freeze({
	WhatsApp: 'wha',
	Sms: 'sms',
});
